import { atom } from '@reatom/framework'

import { environmentAtom } from '@root/shared'

export const premiumConfigAtom = atom(
  (ctx) => ctx.spy(environmentAtom).premium,
  'premiumConfigAtom',
)

export * from './premium-events'

export { reatomPremiumMeta, type PremiumMetaModel } from './reatom-premium-meta'
export * from './reatom-premium-meta-registry'
